<template>
    <div class="home_page">
        <!--banner-->
        <div class="banner">
            <template v-if="(bannerData || {}).length">
                <el-carousel indicator-position="outside">
                    <el-carousel-item v-for="({name,url,imageUrl},index) in bannerData" :key="index">
                        <img :src="imageUrl" :alt="name">
                            <h3><img src="~@/assets/no_img.jpg"></h3>

                    </el-carousel-item>
                </el-carousel>
            </template>
            <template v-else>
                <h1 class="title">鹿路運輸科技平台</h1>
                <img src="~@/assets/ex/banner.png">
            </template>
        </div>
        <!--線上估價-->
        <div class="container">
            <div class="row" v-for="({imageUrl,url},index) in featuresData2" :key="index">
                <router-link :to="url" style="text-decoration: none;">
                    <img :src="imageUrl" class="my-1 w-100">
                </router-link>
            </div>
        </div>
        <!--功能清單-->
        <div class="home_section my-1 rounded" style="background-color: #4495FF">
            <h1 class="title_2 my-1 mb-3 text-white ">其他功能</h1>
            <div class="row " >
                <div class="col-3 mb-2" v-for="({imageUrl, url, name}, index) in featuresData1" :key="index">
                    <router-link :to="url || '/'" style="text-decoration: none;">
                        <div class="d-flex flex-column align-items-center rounded bg-white"
                             style="
                             width: 100%;
                             height: 100%;
                             box-shadow: 6px 6px 2px rgba(0, 0, 0, 0.4); /* 水平偏移、垂直偏移、模糊半徑、顏色 */
                             border-radius: 0px; /* 可選：圓角 */">
                            <img :src="imageUrl" class="my-1">
                            <div class="my-1 px-3" style="line-height:1.3 ;color: #134382">
                                {{ name }}
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <!--優惠活動-->
        <div class="home_section">
            <h1 class="title">優惠活動</h1>
            <ul class="activity_list">
                <li v-for="({name,imageUrl,url},index) in activityData" :key="index" class="item">
                    <router-link :to="url || '/'">
                        <img :src="imageUrl" :alt="name">
                    </router-link>
                </li>
            </ul>
        </div>
        <MENU v-if="!dialogUrlVisible"/>
        <DialogUrl :visbileName="'dialogUrlVisible'" :url="linkData.url" :name="linkData.name"/>
    </div>
</template>
<style>
    .el-carousel__item h3 {
        color: #475669;
        font-size: 18px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }
</style>
<script>

    import FN from '@/components/fn'
    import {mapGetters, mapActions} from 'vuex'
    import MENU from '@/components/menu.vue'
    import DialogUrl from '@/components/DialogUrl'
    import moment from 'moment/min/moment-with-locales'

    export default {
        name: 'Home',
        components: {
            MENU,
            DialogUrl
        },
        mixins: [FN],
        data() {
            return {
                form: {
                    phone: '',
                    password: ''
                },
                notReadCount:[],
            }
        },
        mounted() {
            this.getPromotions()
            this.getBanner()
            this.getNotReadCount();

        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            //取得優惠列表
            getPromotions() {
                this.FETCH({
                    key: 'HOME_PROMOTIONS',
                    phone: this.form.phone
                })
            },
            //取得banner
            getBanner() {
                this.FETCH({
                    key: 'HOME_INFO',
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getBanner)
                    }
                })
            },
            goRegistered() {
                const {href} = this.$router.resolve({name: 'Registered'})
                window.open(href, '_self')
            },
            forgotPassword() {
                const {href} = this.$router.resolve({name: 'ForgotPassword'})
                window.open(href, '_self')
            },
            //取得banner
            getNotReadCount() {
                const today = moment();
                const yesterday = today.subtract(1, 'days');
                const formattedYesterday = yesterday.format('YYYY-MM-DD HH:mm:ss');
                const caseDateTime = localStorage.getItem('caseDateTime') || formattedYesterday;
                const interviewDateTime = localStorage.getItem('interviewDateTime') || formattedYesterday;
                const saleDateTime = localStorage.getItem('saleDateTime') || formattedYesterday;

                this.FETCH({
                    key: 'GET_FORUM_NOT_READ_COUNT',
                    caseDateTime:caseDateTime,
                    interviewDateTime:interviewDateTime,
                    saleDateTime:saleDateTime,
                }).then((res) => {
                    if (+(res || {}).code === 0) {
                        this.notReadCount = {
                            '4':res.data.caseCount,
                            '5':res.data.interviewCount,
                            '6':res.data.saleCount,
                        }

                    }
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getNotReadCount());
                    }
                });
            },
        },
        computed: {
            ...mapGetters([
                'homeInfo',
                'homePromotions'
            ]),
            bannerData() {
                return ((this.homeInfo || {})).banner
            },
            featuresData1() {
                const features = this.homeInfo?.features1
                return features;
                // return features?.filter(({enable}) => enable)
            },
            featuresData2() {
                const features2 = this.homeInfo?.features2
                console.log(features2);
                console.log(features2);
                return features2
                // return features2?.filter(({enable}) => enable)

            },
            activityData() {
                return this.homePromotions?.pagination?.data
            }
        }
    }
</script>
